const prefix = '@@address-search-field/';

export const GET_ADDRESS = prefix + 'GET_ADDRESS';
export const GET_RESULTS = prefix + 'GET_RESULTS';
export const SET_RESULTS = prefix + 'SET_RESULTS';
export const SET_SELECTED_TERM = prefix + 'SET_SELECTED_TERM';
export const SET_LOAD_STATUS = prefix + 'SET_LOAD_STATUS';
export const SET_ERROR = prefix + 'SET_ERROR';
export const INSERT_NEW_KEY = prefix + 'INSERT_NEW_KEY';